import { PopoverGroup } from "@headlessui/react";

import { HeaderCollection, MenuItem } from "./HeaderMenuTypes";
import HeaderMenuItem from "./HeaderMenuItem";
import { HeaderMenuContext } from "./HeaderMenuContext";
import { useMemo } from "react";

interface HeaderMenuProps {
  logo: string;
  menu: MenuItem[];
  headerCollections?: HeaderCollection[];
}

export const HeaderMenuConfig = {
  key: "header-menu",
  component: HeaderMenu,
};

export default function HeaderMenu({
  logo,
  menu,
  headerCollections,
}: HeaderMenuProps) {
  const visibleMenu = menu.filter((item) => !item.mobileOnly);
  const leftMenu = visibleMenu.slice(0, visibleMenu.length / 2);
  const rightMenu = visibleMenu.slice(visibleMenu.length / 2);

  const headerMenuContextValue = useMemo(
    () => ({ headerCollections: headerCollections || [] }),
    [headerCollections]
  );

  return (
    <HeaderMenuContext.Provider value={headerMenuContextValue}>
      <PopoverGroup
        className="
        xflex xitems-stretch xjustify-between
        xw-full
        xh-full
      "
      >
        <div className="xflex xgrow xjustify-end">
          {leftMenu.map((item) => (
            <HeaderMenuItem key={item.title} item={item} />
          ))}
        </div>
        <a className="xflex xshrink-0 xgrow-0 xw-44 sm:xw-80" href="/">
          <img
            className="xw-full xh-auto "
            src={logo}
            loading="lazy"
            alt="green-logo"
            width="316"
            height="auto"
          />
        </a>
        <div className="xflex xgrow xjustify-start">
          {rightMenu.map((item) => (
            <HeaderMenuItem key={item.title} item={item} />
          ))}
        </div>
      </PopoverGroup>
    </HeaderMenuContext.Provider>
  );
}
